import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MultiselectPage } from './multiselect.page';

const routes: Routes = [
  {
    path: '',
    component: MultiselectPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MultiselectPageRoutingModule {}
